<template>
  <div class="pb-4">
    <div v-if="data" class="title">
      <h3 class="section-title">
        {{ data.name.toUpperCase() }}
      </h3>
      <div class="separator" />
    </div>
    <div class="flex flex-row gap-3 align-middle items-center">
      <div v-for="media in mediasToShow" :key="media" class="icon">
        <a
          :href="medias[media].href"
          class="hover:cursor-pointer"
          :aria-label="medias[media].icon"
          target="_blank"
        >
          <!-- <w-icon
            :img="require('@/assets/images/' + medias[media].icon)"
            :size="size"
            @click="media === 'copylink' ? getUrl() : ''"
          /> -->
          <img
            :src="medias[media].icon" 
            alt="" 
            :style="{
              'width': size + 'px',
              'height': size + 'px',
            }"
            @click="media === 'copylink' ? getUrl() : ''"
          />
        </a>
      </div>
    </div>
    <p v-if="successLink" class="copied-successful">
          <span>
            <img
              src="https://cdn.wegow.com/no-delete/wegow/ic-checked-topaz.svg"
              :alt="$t('magazine.links.copySuccess')"/>
          </span>
          {{ $t("magazine.links.copySuccess") }}
      </p>
  </div>
</template>

<script setup>
// import WIcon from "@/components/general/ui/elements/WIcon.vue";
import { toRefs, computed, ref } from "vue";
import { defineProps } from 'vue';

const props = defineProps({
  size: {
    type: Number,
    default: 25
  },
  rounded: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => {}
  },
  mediasToShow: {
    type: Array,
    default: () => [
      "instagram",
      "tiktok",
      "youtube",
      "facebook",
      "twitter",
      "spotify",
      "web",
      "telegram"
    ]
  },
  instagram: {
    type: String,
    default: "https://www.instagram.com/wegowes/"
  },
  tiktok: {
    type: String,
    default: "https://www.tiktok.com/@wegowes?lang=es"
  },
  facebook: {
    type: String,
    default: "https://www.facebook.com/wegow.es/"
  },
  twitter: {
    type: String,
    default: "https://twitter.com/wegowes?lang=es"
  },
  youtube: {
    type: String,
    default: "https://www.youtube.com/channel/UCrftSfN7u5GNiHDy4bBtxHg"
  },
  spotify: {
    type: String,
    default: "https://open.spotify.com/user/wegow?si=5ea40e7fd51945de"
  },
  web: {
    type: String,
    default: "https://www.wegow.com/es-es/"
  },
  telegram: {
    type: String,
    default: ""
  },
  linkedin: {
    type: String,
    default: "https://es.linkedin.com/company/wegow"
  },
  whatsapp: {
    type: String,
    default: ""
  },
  copylink: {
    type: String,
    default: ""
  }
});

const {
  size,
  rounded,
  mediasToShow,
  instagram,
  tiktok,
  facebook,
  twitter,
  youtube,
  spotify,
  web,
  whatsapp,
  telegram,
  linkedin,
} = toRefs(props);

const medias = computed(() => ({
  instagram: {
    icon: rounded.value
      ? "https://cdn.wegow.com/no-delete/wegow/ic-instagram-topaz-black-rounded.svg"
      : "https://cdn.wegow.com/no-delete/wegow/ic-instagram-topaz.svg",
    href: instagram.value
  },
  tiktok: {
    icon: rounded.value
      ? "https://cdn.wegow.com/no-delete/wegow/ic-tiktok-topaz-black-rounded.svg"
      : "https://cdn.wegow.com/no-delete/wegow/ic-tiktok-topaz.svg",
    href: tiktok.value
  },
  facebook: {
    icon: rounded.value
      ? "https://cdn.wegow.com/no-delete/wegow/ic-facebook-topaz-black-rounded.svg"
      : "https://cdn.wegow.com/no-delete/wegow/ic-fb-topaz.svg",
    href: facebook.value
  },
  twitter: {
    icon: rounded.value
      ? "https://cdn.wegow.com/no-delete/wegow/ic-twitter-topaz-black-rounded.svg"
      : "https://cdn.wegow.com/no-delete/wegow/ic-twitter-topaz.svg",
    href: twitter.value
  },
  youtube: {
    icon: rounded.value
      ? "https://cdn.wegow.com/no-delete/wegow/ic-youtube-topaz-black-rounded.svg"
      : "https://cdn.wegow.com/no-delete/wegow/ic-youtube-topaz.svg",
    href: youtube.value
  },
  spotify: {
    icon: rounded.value
      ? "https://cdn.wegow.com/no-delete/wegow/ic-spotify-topaz-black-rounded.svg"
      : "https://cdn.wegow.com/no-delete/wegow/ic-spotify-topaz.svg",
    href: spotify.value
  },
  web: {
    icon: rounded.value ? "https://cdn.wegow.com/no-delete/wegow/ic-web-topaz.svg" : "https://cdn.wegow.com/no-delete/wegow/ic-web-topaz.svg",
    href: web.value
  },
  telegram: {
    icon: rounded.value
      ? "https://cdn.wegow.com/no-delete/wegow/ic-telegram-topaz-black-rounded.svg"
      : "https://cdn.wegow.com/no-delete/wegow/ic-telegram-topaz.svg",
    href: telegram.value
  },
  linkedin: {
    icon: "https://cdn.wegow.com/no-delete/wegow/ic-linkedin-topaz-black-rounded.svg",
    href: linkedin.value
  },
  whatsapp: {
    icon: "https://cdn.wegow.com/no-delete/wegow/ic-whatsapp-topaz-black-rounded.svg",
    href: whatsapp.value
  },
  copylink: {
    icon: "https://cdn.wegow.com/no-delete/wegow/ic-copylink-topaz-black-rounded.svg"
  }
}));
const successLink = ref(false);
const getUrl = async () => {
  const textarea = document.createElement("textarea");
  textarea.value = location.href;
  textarea.style.position = "fixed";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
  successLink.value = true;
  setTimeout(() => {
    successLink.value = false;
  }, 1500);
};
// const getWtsa = url => {
//   const message = encodeURIComponent(location.href);
//   window.open(url + message);
// };
</script>

<style lang="scss" scoped>
.copied-successful {
    display: flex;
    margin-top: 2.6rem;
    color: $black;
    span {
      margin-right: 6px;
      img {
        margin: auto;
      }
    }
  }
</style>
